import {Region} from "./Regions";

export interface Country {
    id: number;
    name: string;
    code: string;
    regions: (number | Region)[];
}
